import Vue from "vue";
import VueRouter from "vue-router";
import M from "@/libs/mapping.js";
import { CAFE24_ROUTES } from "./cafe24.js";
import { SHOPLUS_ROUTES } from "./shoplus.js";

import SetStoreInfo from "@/libs/authservice/setting-store-info.js";


Vue.use(VueRouter);


//url path 앞자리 ( ex : http://localhost:8080/shoplus_service => shoplus_service )
let path = M.urlPath();

//routes 배열 담을 변수
let routeArray = [];

/**
 * 경로에 따른 routes
 */
switch (path) {
  case "shoplus_service":
  case "shoplus_authservice":
    routeArray = SHOPLUS_ROUTES;
    break;
  default:
    routeArray = CAFE24_ROUTES;
    break;
}

const routes = routeArray;
const router = new VueRouter({
  mode: "history",
  routes,
});


/**
 * store 정보 세팅
 */
new SetStoreInfo(router, path);


export default router;
